<mat-card data-cy="notification-card" class="tw-mb-2 notification-card" [ngClass]="{'incoming-call': isIncomingCall}" [@animation]>
  <mat-card-content>
    <ng-container *ngIf="isIncomingCall; else defaultLayout">
      <div class="tw-flex tw-items-start" [ngClass]="notification.navigationRoute ? 'tw-cursor-pointer' : ''" (click)="notification.navigationRoute ? navigateTo() : ''">
        <div class="tw-grow-0 tw-mr-4 tw-flex tw-items-center tw-justify-center incoming-call-icon tw-rounded-full tw-w-10 tw-h-10">
          <svg class="tw-w-5 tw-h-5" viewBox="0 0 12.7075 12.7601" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.57 2.833a4.16 4.16 0 0 1 2.304 2.304M7.57.5a6.49 6.49 0 0 1 4.638 4.632M5.34 7.42a9.07 9.07 0 0 1-1.66-2.339.6.6 0 0 1-.066-.155.47.47 0 0 1 .086-.503c.028-.039.061-.072.128-.139a.78.78 0 0 0 .373-.409.78.78 0 0 0 0-.552.78.78 0 0 0-.373-.408l-.113-.114c-.31-.31-.465-.465-.632-.55a.93.93 0 0 0-1.053.001c-.167.084-.322.239-.632.55l-.092.091c-.31.31-.464.464-.582.674a1.62 1.62 0 0 0-.224.862c0 .241.047.406.14.735a12.35 12.35 0 0 0 2.843 4.832 12.35 12.35 0 0 0 4.832 2.843c.33.093.494.14.735.141.267 0 .629-.094.862-.225.21-.118.365-.272.674-.582l.092-.092c.31-.31.465-.465.55-.631a.93.93 0 0 0 0-1.054c-.084-.166-.24-.321-.55-.631l-.113-.114a.78.78 0 0 0-.409-.372.78.78 0 0 0-.552 0 .78.78 0 0 0-.408.372c-.067.067-.1.1-.14.128a.47.47 0 0 1-.502.086.6.6 0 0 1-.155-.066 9.07 9.07 0 0 1-2.34-1.66Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"/>
          </svg>
        </div>
        <div class="tw-flex-grow tw-cursor-pointer" (click)="navigateTo()">
          <div class="tw-font-bold tw-text-base">
            {{ notification.heading ? notification.heading : notification.type | titlecase }}
          </div>
          <div class="tw-text-gray-500">
            {{ notification.title }}
          </div>
          <div
            class="tw-pt-1"
            *ngIf="notification.content"
            [innerHtml]="notification.content">
          </div>
        </div>
      </div>
      <div *ngIf="notification.actions" class="tw-flex tw-gap-3 tw-mt-3">
        <button
          *ngFor="let action of notification.actions"
          [ngClass]="{
            'tw-bg-lendio-red-500 hover:tw-bg-lendio-red-600': action.text === 'Dismiss',
            'tw-bg-lendio-green-500 hover:tw-bg-lendio-green-600': action.text === 'Start Call'
          }"
          class="tw-flex-1 tw-py-1 tw-px-1.5 tw-text-xs tw-font-semibold tw-text-white tw-border-none tw-rounded-lg tw-cursor-pointer tw-inline-flex tw-items-center tw-justify-center tw-gap-1.5"
          (click)="action.function(); handleDismiss();">
          <mat-icon *ngIf="action.text === 'Dismiss'" class="tw-text-base">call_end</mat-icon>
          <mat-icon *ngIf="action.text === 'Start Call'" class="tw-text-base">call</mat-icon>
          {{ action.text }}
        </button>
      </div>
    </ng-container>

    <ng-template #defaultLayout>
      <div class="tw-flex" [ngClass]="notification.navigationRoute ? 'tw-cursor-pointer' : ''" (click)="notification.navigationRoute ? navigateTo() : ''">
        <div class="tw-grow-0 tw-mr-4 tw-text-center">
          <mat-icon [class]="notification.color + ' icon tw-rounded-full tw-leading-relaxed'">
            {{ notification.icon }}
          </mat-icon>
        </div>
        <div class="tw-flex-grow">
          <div class="tw-flex">
            <div class="tw-flex-grow tw-cursor-pointer" (click)="navigateTo()">
              <div class="tw-font-bold tw-text-base">
                {{ notification.heading ? notification.heading : notification.type | titlecase }}
              </div>
              <div class="tw-text-gray-500">
                {{ notification.title }}
              </div>
            </div>
            <div
              (click)="handleDismiss()"
              *ngIf="notification.dismissible && notification.type !== 'callQueue' && !notification.hideDismissButton"
              class="tw-cursor-pointer tw-grow-0"
              data-cy="close-notification-btn">
              <mat-icon>close</mat-icon>
            </div>
          </div>
          <div class="tw-flex tw-pt-1 tw-flex-row">
            <div
              class="tw-flex-auto"
              *ngIf="notification.content"
              [innerHtml]="notification.content">
            </div>
          </div>
          <div>
            <div *ngIf="notification.actions">
              <div class="tw-text-right tw-mt-2">
                <div *ngIf="notification.actions.length < 3; else actionsMenu">
                  <button
                    color="primary"
                    class="tw-ml-2"
                    mat-button
                    *ngFor="let action of notification.actions"
                    (click)="action.function(); handleDismiss();">
                    {{ action.text }}
                  </button>
                </div>
                <ng-template #actionsMenu>
                  <button
                    mat-button
                    color="primary"
                    [matMenuTriggerFor]="menu">
                    Actions <mat-icon style="transform:translate(0px, -2px);">arrow_drop_down</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button
                      mat-menu-item
                      *ngFor="let action of notification.actions"
                      (click)="action.function(); handleDismiss();">
                      {{ action.text }}
                    </button>
                  </mat-menu>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
